import { message } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getSponsors } from "../../../../../controller/services/settings";
import i18n from "../../../../../localization/i18n";
import { setLoading } from "../../../../../redux/slices/common_slice";
import RightSideSettingsWrapper from "../../rightside-details-settings/RightSideSettingsWrapper";

const Index = () => {
  const [sponsors, setSponsors] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    getSponsorsList();
  }, []);

  const getSponsorsList = () => {
    dispatch(setLoading(true));
    getSponsors()
      .then((resp) => {
        setSponsors(resp.data.sponsor);
      })
      .catch((Err) => {
        message.error(Err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  return (
    <RightSideSettingsWrapper>
      {sponsors?.map((sponsor) => {
        return (
          <a href={sponsor?.link} key={sponsor?._id} target="_blank">
            <div className="row mx-0 details-common-card-row partner-row-card">
              <div className="col-12 text-center">
                <img
                  src={sponsor?.logo}
                  alt=""
                  className="img-fluid partner-img"
                />
                <div className="w-100 text-center d-block partner-sponsers-name">
                  {sponsor?.title[i18n.language]}
                </div>
              </div>
            </div>
          </a>
        );
      })}
    </RightSideSettingsWrapper>
  );
};

export default Index;
